import { userRightsGroupRequest } from '@/network/requests/userRightsGroup'
import { userRightsGroupDetailRequest } from '@/network/requests/userRightsGroupDetail'
import { userRightsRequest } from '@/network/requests/userRights'
import { user_rights_group } from '@/interfaces/user_rights_group'
import { queryUsers, userRequest } from '@/network/requests/user'
import { user } from '@/interfaces/user'
import { workshopRequest } from '@/network/requests/workshop'

/**
 * 保存用户。
 * @param user 用户对象。
 */
var saveUser = (user: user) => {
	if (user._id) {
		return userRequest.modifyById(user._id.$oid, user)
	} else {
		return userRequest.upload(user)
	}
}

/**
 * 获取所有角色。
 */
var getRoles = async () => {
	//角色详情
	var userRightsGroupDetail = await userRightsGroupDetailRequest.queryAll()
	//所有角色。
	var roles = await userRightsGroupRequest.queryAll()
	//所有权限。
	var rights = await userRightsRequest.queryAll()

	var roleArray: any[] = []
	//遍历角色。
	roles.forEach(async element => {
		var userRightsGroupDetails = userRightsGroupDetail.filter(t => t.user_rights_group_id == element._id?.$oid)
		var functions: any[] = []

		//遍历角色详情，增加角色名称。
		userRightsGroupDetails.forEach(urgd => {
			var f = rights.find(p => p._id?.$oid == urgd.rights_id)
			if (f) {
				functions.push(f)
			}
		})

		//获取用户数量。
		var users = await userRequest.queryAll({ user_rights_group: element._id?.$oid }, { id: 1 })

		roleArray.push({
			id: element._id?.$oid,
			name: element.name!,
			functions: functions,
			user_count: users.length,
		})
	})

	return roleArray
}

/**
 * 获取角色键值对。
 */
var getRoleKeyValues = async () => {
	//所有角色。
	var roles = await userRightsGroupRequest.queryAll()

	return roles.map(p => ({
		key: p._id?.$oid,
		value: p.name!,
	}))
}

/**
 * 保存角色。
 * @param roleInfo 角色信息。
 */
var saveRole = async (roleInfo: user_rights_group) => {
	if (roleInfo._id) {
		await userRightsGroupRequest.modifyById(roleInfo._id.$oid, roleInfo)
	} else {
		await userRightsGroupRequest.upload(roleInfo)
	}
}

/**
 * 删除角色。
 * @param id 角色Id。
 */
var deleteRole = async (id: string) => {
	//删除角色。
	await userRightsGroupRequest.deleteById(id)
	//删除角色和权限的关联。
	await userRightsGroupDetailRequest.deleteBatch({ user_rights_group_id: id })
}

/**
 * 删除用户。
 * @param id 用户Id。
 */
var deleteUser = async (id: string) => {
	await userRequest.deleteById(id)
}

/**
 *
 * @param roleId
 * @param ids
 */
var saveRoleRights = async (roleId: string, ids: string[]) => {
	//删除现有的权限
	await userRightsGroupDetailRequest.deleteBatch({ user_rights_group_id: roleId })

	var details = ids.map((v, i) => {
		return {
			user_rights_group_id: roleId,
			rights_id: v,
		}
	})

	return userRightsGroupDetailRequest.uploadBatch(details)
}

/**
 *
 * @param pageIndex
 * @param pageSize
 * @param userName
 */
var getUsers = async (pageIndex: number, pageSize: number, userName: string) => {
	var users = await queryUsers(pageSize, pageIndex, { name: userName })
	var array: any = []

	var roleKeyValues = await getRoleKeyValues()
	var wokshops = await workshopRequest.queryAll()

	users.data._embedded.forEach((v, i) => {
		//角色名称。
		var userRole = roleKeyValues.find(t => t.key == v.user_rights_group!)

		//车间名称。
		var workshop = wokshops.find(t => t._id?.$oid == v.workshop_id)

		array.push({ ...v, workshop_name: workshop?.name, role: userRole?.value })
	})

	return array
}

export default {
	getRoles,
	getRoleKeyValues,
	saveRole,
	deleteRole,
	deleteUser,
	saveRoleRights,
	saveUser,
	getUsers,
}
